@if (is_loading) {
  <div class="loader-container flex-col m-3 ">
    @for (item of loadingItems; track item) {
      <div>
        <div class="flex loader-body" id="{{ item.id }}" style="width: 100%;">
          <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
            <div class="ph-col-12" style="padding: 0px !important">
              <div class="ph-row">
                <div class="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}

@if (associate_form_list.length == 0 && !is_loading) {
  <div style="display: flex;justify-content: center;height: 48px;padding-top: 12px;"  class="mb-4  mx-3 mt-4 bg-[#D9D9D9] border-dashed rounded-sm  border-2 text-center"
    >
    <mat-icon style="font-size: 24px !important;transform: rotate(-35deg);position: relative;top: -2px;"  class="text-[#515765] text-sm font-normal" >link</mat-icon>
    @for (reminder of action_type_config_list; track reminder; let i = $index) {
      @if (i == currentStep) {
        <ng-container class="flex flex-row justify-between">
          <p  class="text-[#515765] mb-0 text-sm font-normal">No {{reminder.description}} has been linked</p>
        </ng-container>
      }
    }
  </div>
}
<div class="flex flex-col overflow-auto" style="max-height: 290px;" >
  @for (associate_form of associate_form_list; track associate_form; let i = $index) {
    <div class="flex  h-[72px] text-sm  m-3 justify-between rounded-lg border border-solid  border-[#53565B38]" >
      <div class="flex " >
        <div class="m-3">
          <ngx-avatars
            size="48"
            src="{{ associate_form?.profile_image_url }}"
            name="{{ associate_form?.form_name }}"
            [round]="true"
            initialsSize="2"
          ></ngx-avatars>
        </div>
        <p class="text-sm leading-[72px] font-semibold "  >{{associate_form?.form_name}}</p>
      </div>
      <div class="m-3" style="padding-top: 8px;">
        <button mat-menu-item                              (click)="deleteUserFormAssociation(associate_form.id, associate_form.form_name, associate_form)"  class="p-0  bg-[#EB57571F] h-8 w-8 text-center rounded-full" >
          <span class="material-icons material-icons-round menuitem-icon text-[#EB5757]">delete</span>
        </button>
      </div>
    </div>
  }

</div>

<div class="mx-3 flex" >
  @for (reminder of action_type_config_list; track reminder; let i = $index) {
    @if (i == currentStep && !is_mx_btn_needed) {
      <ng-container class="flex flex-row justify-between">
        <button
          (click)="createForm()"
          style="padding: 0px !important; line-height: 38px !important;margin-bottom: 12px !important;"
          class=" app__btn--primary mt-0  h-[38px] "
          type="submit"
          >
          Add New
        </button>
      </ng-container>
    }
    @if (i == currentStep && is_mx_btn_needed) {
      <ng-container class="flex flex-row justify-between">
        <button
          (click)="connectMX(reminder)"
          style="padding: 0px !important; line-height: 38px !important;margin-bottom: 12px !important;"
          class=" app__btn--primary mt-0  h-[38px]  mr-1.5"
          type="submit"
          >
          Connect with MX
        </button>
        <button
          (click)="createForm()"
          style="padding: 0px !important; line-height: 38px !important;margin-bottom: 12px !important;"
          class=" app__btn--primary mt-0  h-[38px] ml-1.5"
          type="submit"
          >
          Add Manually
        </button>
      </ng-container>
    }
  }
</div>
@if (associate_form_list?.length == 0 ) {
  <div class="mx-3" >
    @for (reminder of action_type_config_list; track reminder; let i = $index) {
      @if (i == currentStep) {
        <div class="flex flex-row justify-between">
          <mat-checkbox class="automatic-form-checkbox"
            [(ngModel)]="selectDOntAdd"
            >
            <mat-label class="automtic-form-desing-lable">
              I don’t want to link a {{reminder.description}}
            </mat-label>
          </mat-checkbox>
        </div>
      }
    }
  </div>
}

